import React, { useState, useEffect } from 'react';
import { Users } from 'lucide-react';

const VisitorCounter = () => {
  const [count, setCount] = useState(1986895);

  useEffect(() => {
    // Lógica para simular o crescimento do contador no frontend
    const baseDate = new Date('2026-04-14T00:00:00').getTime();
    const now = new Date().getTime();
    const hoursPassed = Math.floor((now - baseDate) / (1000 * 60 * 60));

    // Simula um crescimento de ~3 visitantes por hora desde a data base
    const simulatedGlobalCount = 1986895 + (hoursPassed > 0 ? hoursPassed * 3 : 0);

    // Verifica se é a primeira visita deste usuário específico
    const hasVisited = localStorage.getItem('hasVisited_CafeColonial');

    if (!hasVisited) {
      localStorage.setItem('hasVisited_CafeColonial', 'true');
      setCount(simulatedGlobalCount + 1);
    } else {
      setCount(simulatedGlobalCount);
    }
  }, []);

  return (
    <section className="py-10 bg-[#8B4513] border-y-4 border-[#DAA520]" data-testid="visitor-counter">
      <div className="max-w-4xl mx-auto px-4 flex flex-col items-center justify-center text-center">
        <Users size={40} className="text-[#DAA520] mb-4" />
        <h3 className="text-4xl md:text-6xl font-bold text-[#F5F0E6] tracking-wider mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          {count.toLocaleString('pt-BR')}
        </h3>
        <div className="w-16 h-1 bg-[#DAA520] mx-auto my-3 rounded-full"></div>
        <p className="text-[#D4C8B4] text-sm md:text-base uppercase tracking-[0.2em] font-semibold mt-2">
          Visitantes apaixonados por nossas cestas
        </p>
      </div>
    </section>
  );
};

export default VisitorCounter;